import * as actionTypes from '../actions/ActionTypes';
import { REHYDRATE } from 'redux-persist';

const initialCommonState = {
  data: [],
  leaderBoardData: [],
  AchievementData: [],
  ChallengeSendData: [],
  ChallengeAcceptData: [],
  ChallengeHistoryList: [],
};

const DashBoardReducer = (state = { ...initialCommonState }, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_DASHBOAD_DETAILS:
      return {
        ...state,
        data: action.data,
      };

    case actionTypes.LOGOUT:
      return { ...initialCommonState };

    case actionTypes.UPDATE_CHALLENGE_SEND_LIST:
      return {
        ...state,
        challengeSendData: action.data,
      };

    case actionTypes.UPDATE_LEADERBOARD_DETAILS:
      return {
        ...state,
        leaderBoardData: action.data,
      };
    case actionTypes.UPDATE_ACHIEVEMENT_DETAILS:
      return {
        ...state,
        AchievementData: action.data,
      };

    case REHYDRATE:
      return {
        ...state,
        ...((action.payload || {}).DashBoardReducer || {}),
      };
    case actionTypes.CHANGE_PASSWORD:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default DashBoardReducer;
